import { useState } from "react";
import { Button, TextField, IconButton } from "@mui/material";
import flowers from "../../../../assets/plants/flowers.jpg";
import fruits from "../../../../assets/plants/fruits.jpeg";
import palms from "../../../../assets/plants/palms.jpg";
// import ficus from "../../../../assets/plants/ficuss.jpg";
import acer from "../../../../assets/plants/acer.jpg";
// import olives from "../../../../assets/plants/olivess.jpg";
import climbers from "../../../../assets/plants/climbing-jasmine-lifestyle-scaled.jpg";
import cedrus from "../../../../assets/cedrus.jpeg";
import blossom from "../../../../assets/plants/bloss.jpg";
import indoors from "../../../../assets/plants/indoor.jpg";
// import quercus from "../../../../assets/plants/quercus.jpg";
import shapes from "../../../../assets/plants/shapes (2).jpg";
import ficus from '../../../../assets/best-ficus.jpeg'
import olives from '../../../../assets/olive-best.jpeg';
import quercus from '../../../../assets/best-oak.jpeg'
import "./plantsCategoriesMobile.css";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../components/back/back";



export default function PlantsCategoriesMobile() {
    const [searchTerm, setSearchTerm] = useState("");
    const [viewMode, setViewMode] = useState("grid");
    const navigate = useNavigate()
    const plants = [
        { id: 1, name: "Ficus", img: ficus, url: "/ficus" },
        { id: 2, name: "Cedrus", img: cedrus, url: "/cedrus" },
        { id: 3, name: "Acer", img: acer, url: "/acer" },
        { id: 4, name: "Palms", img: palms, url: "/palms" },
        { id: 5, name: "Blossom Trees", img: blossom, url: "/blossom" },
        { id: 6, name: "Olives", img: olives, url: "/olives" },
        { id: 12, name: "Quercus", img: quercus, url: "/quercus" },
        { id: 7, name: "Indoors", img: indoors, url: "/indoors" },
        { id: 8, name: "Shapes", img: shapes, url: "/shapes" },
        { id: 9, name: "Fruits", img: fruits, url: "/fruits" },
        { id: 10, name: "Flowers", img: flowers, url: "/flowers" },
        { id: 11, name: "Climbers", img: climbers, url: "/climbers" },

    ];


    const filteredPlants = plants.filter((plant) =>
        plant.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <BackIcon />

            <div className="title-overlay-mobile">
                <h1>🌿 Where Green Dreams Grow 🌿</h1>
            </div>


            <div className="search-and-toggle">
                <TextField
                    label="Search for a plant..."
                    variant="outlined"
                    size="small"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "25px",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "25px",
                        },
                    }}
                />
            </div>

            <div className="plants-wrapper">
                <div className={`plants-category-container-mobile ${viewMode}`}>
                    {filteredPlants.map((plant) => (
                        <div key={plant.id} className={`plant-card ${viewMode}`} onClick={() => { navigate(plant.url) }} style={{ cursor: "pointer" }}>
                            <img src={plant.img} alt={plant.name} className="plant-image" />
                            <p className="plant-name">{plant.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
